import { Component } from '@angular/core';
import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './analytics.component.html',
    standalone: false
})
export class AnalyticsModalComponent extends BaseModalDirective {}
